import styled, { css } from "styled-components";

const glassCard = css`
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

export const ProfileContainer = styled.div`
  min-height: 100vh;
  padding: 110px 20px 40px;
  color: #ffffff;
  background:
    radial-gradient(circle at top, rgba(212, 175, 55, 0.08), transparent 35%),
    linear-gradient(180deg, #050506 0%, #0a0b10 100%);

  @media screen and (max-width: 768px) {
    padding: 92px 14px 28px;
  }

  @media screen and (max-width: 420px) {
    padding: 86px 10px 22px;
  }
`;

export const ProfileHeader = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 24px auto;

  h1 {
    margin: 0;
    font-size: clamp(2rem, 4vw, 4rem);
    font-weight: 900;
    letter-spacing: -0.02em;
    color: #ffffff;
    line-height: 1.05;
    word-break: break-word;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 18px;
  }
`;

export const ProfilePictureWrap = styled.div`
  ${glassCard};
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 22px auto;
  border-radius: 24px;
  padding: 28px 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: 768px) {
    padding: 20px 1px;
    border-radius: 18px;
    margin-bottom: 18px;
  }

  @media screen and (max-width: 420px) {
    padding: 16px 1px;
    border-radius: 16px;
  }
`;

export const ProfileAvatar = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 999px;
  overflow: hidden;

  display: grid;
  place-items: center;

  background: linear-gradient(
    135deg,
    rgba(0, 103, 114, 0.96),
    rgba(212, 175, 55, 0.72)
  );
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);

  ${({ $clickable }) => ($clickable ? "cursor: pointer;" : "")}
  transition: transform 0.15s ease, box-shadow 0.2s ease, border 0.2s ease;

  &:hover {
    transform: ${({ $clickable }) => ($clickable ? "translateY(-2px)" : "none")};
    border-color: ${({ $clickable }) =>
      $clickable ? "rgba(212, 175, 55, 0.4)" : "rgba(255,255,255,0.16)"};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  span {
    color: rgba(255, 255, 255, 0.96);
    font-weight: 900;
    font-size: 1.4rem;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 768px) {
    width: 104px;
    height: 104px;

    span {
      font-size: 1.2rem;
    }
  }

  @media screen and (max-width: 420px) {
    width: 92px;
    height: 92px;
  }
`;

export const UploadHint = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.74);
  text-align: center;
  font-weight: 600;
  line-height: 1.5;
  max-width: 100%;
  word-break: break-word;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const StatusMessage = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 18px auto;
  border-radius: 16px;
  padding: 14px 16px;

  font-weight: 800;
  line-height: 1.5;
  word-break: break-word;

  color: ${({ success }) => (success ? "#d1fae5" : "#fecaca")};
  background: ${({ success }) =>
    success ? "rgba(16, 185, 129, 0.16)" : "rgba(239, 68, 68, 0.16)"};
  border: 1px solid
    ${({ success }) =>
      success ? "rgba(16, 185, 129, 0.28)" : "rgba(239, 68, 68, 0.28)"};

  @media screen and (max-width: 768px) {
    padding: 12px 14px;
    border-radius: 14px;
    margin-bottom: 14px;
    font-size: 0.95rem;
  }
`;

/* Stats */
export const StatsGrid = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 22px auto;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 18px;
  }
`;

export const StatCard = styled.div`
  ${glassCard};
  border-radius: 22px;
  padding: 22px 20px;
  min-width: 0;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    padding: 18px 16px;
    border-radius: 18px;
  }

  @media screen and (max-width: 420px) {
    padding: 16px 14px;
    border-radius: 16px;
  }
`;

export const StatLabel = styled.div`
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 1.4;
  word-break: break-word;

  @media screen and (max-width: 420px) {
    font-size: 0.82rem;
  }
`;

export const StatValue = styled.div`
  margin-top: 10px;
  color: #f4d37a;
  font-size: clamp(1.6rem, 3vw, 2.8rem);
  font-weight: 900;
  line-height: 1.1;
  word-break: break-word;
`;

export const StatSub = styled.div`
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.55;
  word-break: break-word;

  @media screen and (max-width: 420px) {
    font-size: 0.9rem;
  }
`;

/* Parrainage */
export const ReferralCard = styled.div`
  ${glassCard};
  width: 100%;
  max-width: 1180px;
  margin: 0 auto 22px auto;
  border-radius: 24px;
  padding: 24px;
  min-width: 0;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    padding: 18px 1px;
    border-radius: 18px;
    margin-bottom: 18px;
  }

  @media screen and (max-width: 420px) {
    padding: 16px 1px;
    border-radius: 16px;
  }
`;

export const ReferralLabel = styled.div`
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 1.4;
  word-break: break-word;

  @media screen and (max-width: 420px) {
    font-size: 0.82rem;
  }
`;

export const ReferralCode = styled.div`
  margin-top: 12px;
  width: 100%;
  max-width: 100%;
  border-radius: 16px;
  padding: 16px 1px;

  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.04),
    0 18px 40px rgba(0, 0, 0, 0.28);

  color: #f4d37a;
  font-weight: 900;
  font-size: clamp(1rem, 2vw, 2rem);
  letter-spacing: 0.08em;
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;

  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;

  @media screen and (max-width: 768px) {
    padding: 14px 1px;
    border-radius: 14px;
    font-size: clamp(0.92rem, 4vw, 1.25rem);
    letter-spacing: 0.04em;
  }
`;

export const ReferralSub = styled.div`
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.95rem;
  line-height: 1.6;
  font-weight: 600;
  word-break: break-word;

  @media screen and (max-width: 420px) {
    font-size: 0.9rem;
  }
`;

export const CopyBtn = styled.button`
  margin-top: 16px;
  min-height: 48px;
  padding: 0 18px;
  border: none;
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    135deg,
    rgba(0, 103, 114, 0.96),
    rgba(212, 175, 55, 0.88)
  );
  color: #ffffff;
  font-size: 0.96rem;
  font-weight: 900;
  cursor: pointer;

  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.34);
  transition: transform 0.15s ease, opacity 0.2s ease;
  word-break: break-word;

  &:hover {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    min-height: 46px;
    font-size: 0.94rem;
  }
`;

export const ProfileDetails = styled.div`
  ${glassCard};
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  border-radius: 24px;
  padding: 10px;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media screen and (max-width: 768px) {
    padding: 8px;
    gap: 12px;
    border-radius: 18px;
  }

  @media screen and (max-width: 420px) {
    padding: 6px;
    gap: 10px;
    border-radius: 16px;
  }
`;

export const ProfileDetailItem = styled.div`
  min-height: 74px;
  border-radius: 18px;
  padding: 18px 16px;

  background: #0e1014;
  border: 1px solid rgba(255, 255, 255, 0.09);

  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 600;

  min-width: 0;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: anywhere;

  strong {
    color: #ffffff;
    font-weight: 900;
  }

  @media screen and (max-width: 768px) {
    min-height: auto;
    padding: 16px 1px;
    border-radius: 16px;
    font-size: 0.96rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 420px) {
    padding: 14px 1px;
    border-radius: 14px;
    font-size: 0.92rem;
  }
`;